var map = {
	"./cardio.png": 1123,
	"./core.png": 6064,
	"./hybrid.png": 8831,
	"./ic-booking.png": 5427,
	"./ic-booking_green.png": 9855,
	"./ic-dashboard.png": 8554,
	"./ic-dashboard_green.png": 9566,
	"./ic-profile.png": 1849,
	"./ic-profile_green.png": 197,
	"./ic-records.png": 1620,
	"./ic-records_green.png": 8032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;